import { useState, useEffect } from 'react';
import './Missao.css';
import imgMission01 from '../../assets/img/img-mission-01.png';
import imgMission02 from '../../assets/img/img-mission-02.png';
import imgMission03 from '../../assets/img/img-mission-03.png';

const MISSAO_IMGS = [imgMission01, imgMission02, imgMission03];

export default function Missao() {
  const [current, setCurrent] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % MISSAO_IMGS.length);
        setFading(false);
      }, 600);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="missao" className="missao">

      {/* Blob decorativo de fundo */}
      <div className="missao__blob" />

      <div className="missao__inner">

        {/* ── Linha superior: imagem + texto ── */}
        <div className="missao__row">

          {/* Imagem com moldura estilizada */}
          <div className="missao__visual-wrap">
            <div className="missao__img-frame">
              <div className="missao__slider">
                <img
                  src={MISSAO_IMGS[current]}
                  alt="Missão Amanimal Shop"
                  className={`missao__slider-img ${fading ? 'missao__slider-img--fading' : ''}`}
                />
                <div className="missao__slider-dots">
                  {MISSAO_IMGS.map((_, i) => (
                    <span
                      key={i}
                      className={`missao__slider-dot ${i === current ? 'missao__slider-dot--active' : ''}`}
                    />
                  ))}
                </div>
              </div>
              {/* Cartão flutuante de destaque */}
              <div className="missao__float-card">
                <span className="missao__float-icon">🐾</span>
                <div>
                  <strong>ONG Amanimal</strong>
                  <p>Amor em forma de moda</p>
                </div>
              </div>
            </div>
            {/* Quadrado decorativo atrás */}
            <div className="missao__deco-square" />
          </div>

          {/* Texto */}
          <div className="missao__content">
            <span className="section-tag">Nossa Missão</span>

            <h2 className="missao__title">
              Nascemos para<br />
              <span className="missao__title-accent">fazer a diferença</span>
            </h2>

            <p className="missao__intro">
              A Amanimal Shop nasceu como um canal de vendas com o objetivo de captar
              recursos para apoiar e manter o trabalho social desenvolvido pela ONG.
            </p>


          </div>
        </div>

        {/* ── Banner de impacto ── */}
        <div className="missao__banner">
          <p className="missao__banner-text">
            "Cada peça vendida ajuda a ONG Amanimal a oferecer abrigo, alimentação e cuidado
            para animais que precisam de uma chance enquanto aguardam por uma família."
          </p>
          <div className="missao__banner-paws">🐾🐾🐾</div>
        </div>

      </div>
    </section>
  );
}
